module.exports = "images/expert-craftmanship@3x.webp";